import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Vidya Vatika World School | Premier CBSE School in Panipat',
  description = 'Top CBSE School in Panipat offering excellence in academics, sports & arts. Admissions open for 2026-27. Nursery to Class 12.',
  keywords = 'CBSE school Panipat, best school in Panipat, Vidya Vatika, top school Haryana, admissions 2026',
  canonicalUrl = '/',
  ogImage = '/images/og-image.jpg',
  ogType = 'website',
  article = false,
  author = 'Vidya Vatika World School',
  publishedTime = null,
  modifiedTime = null,
  section = null
}) => {
  const fullTitle = title.includes('|') ? title : `${title} | Vidya Vatika`;
  const url = canonicalUrl.startsWith('http') ? canonicalUrl : `https://www.vidyavatika.com${canonicalUrl}`;
  const imageUrl = ogImage.startsWith('http') ? ogImage : `https://www.vidyavatika.com${ogImage}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={article ? 'article' : ogType} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:site_name" content="Vidya Vatika World School" />
      
      {/* Article Specific (for news/blog) */}
      {article && (
        <>
          <meta property="article:published_time" content={publishedTime} />
          <meta property="article:modified_time" content={modifiedTime} />
          <meta property="article:section" content={section} />
          <meta property="article:author" content={author} />
        </>
      )}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:creator" content="@vidyavatika" />
      <meta name="twitter:site" content="@vidyavatika" />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />
      <meta name="yahoo" content="index, follow" />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="IN-HR" />
      <meta name="geo.placename" content="Panipat" />
      <meta name="geo.position" content="29.3909;76.9635" />
      <meta name="ICBM" content="29.3909, 76.9635" />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": article ? "Article" : "EducationalOrganization",
          "name": "Vidya Vatika World School",
          "url": url,
          "logo": "https://www.vidyavatika.com/images/logo.png",
          "description": description,
          "image": imageUrl,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "G.T. Road, Near Railway Crossing",
            "addressLocality": "Panipat",
            "addressRegion": "Haryana",
            "postalCode": "132103",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 29.3909,
            "longitude": 76.9635
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-90348-51777",
            "contactType": "admissions"
          },
          "sameAs": [
            "https://www.facebook.com/vidyavatikaworld",
            "https://www.instagram.com/vidyavatikaworld",
            "https://x.com/VidyaVatikaPNP"
          ],
          ...(article && {
            "author": {
              "@type": "Organization",
              "name": author
            },
            "datePublished": publishedTime,
            "dateModified": modifiedTime
          })
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
